import React from 'react';
import './TeamGallery.css';
import { AnimatedSection } from '../../AnimatedSection';

const TeamGallery = () => {
  // Leadership team images (3 people)


  return (
    <section className="team-gallery section">
      <div className="team-gallery-container-desktop">
        {/* Main content area */}
        <div className="team-content">
          {/* Left side - Leadership Team */}
          <div className="leadership-section  flex gap-3">
            <div className='flex gap-4 justify-center'>
              <div style={{maxWidth: '180px'}}><img src="/home_data/section4/1.png" alt="Leadership Member 1" className="portrait-image" /></div>
              <div style={{maxWidth: '180px'}}><img src="/home_data/section4/2.png" alt="Leadership Member 1" className="portrait-image" /></div>
              <div style={{maxWidth: '180px'}}><img src="/home_data/section4/3.png" alt="Leadership Member 1" className="portrait-image" /></div>

              <div className='px-10'  ><img src="/home_data/section4/THE TEAM.png" alt="Leadership Member 1" className="portrait-image" /></div>


              <div style={{maxWidth: '180px'}}><img src="/home_data/section4/4.png" alt="Leadership Member 1" className="portrait-image" /></div>
              <div style={{maxWidth: '180px'}}><img src="/home_data/section4/5.png" alt="Leadership Member 1" className="portrait-image" /></div>
              <div style={{maxWidth: '180px'}}><img src="/home_data/section4/6.png" alt="Leadership Member 1" className="portrait-image" /></div>
              <div style={{maxWidth: '180px'}}><img src="/home_data/section4/7.png" alt="Leadership Member 1" className="portrait-image" /></div>
              <div style={{maxWidth: '180px'}}><img src="/home_data/section4/8.png" alt="Leadership Member 1" className="portrait-image" /></div>
              {/* <img src="/home_data/section4/2.png" alt="Leadership Member 1" className="portrait-image" />
              <img src="/home_data/section4/3.png" alt="Leadership Member 1" className="portrait-image" />
              <img src="/home_data/section4/THE TEAM.png" alt="Leadership Member 1" className="portrait-image" />
              <img src="/home_data/section4/4.png" alt="Leadership Member 1" className="portrait-image" />
              <img src="/home_data/section4/5.png" alt="Leadership Member 1" className="portrait-image" />
              <img src="/home_data/section4/6.png" alt="Leadership Member 1" className="portrait-image" />
              <img src="/home_data/section4/7.png" alt="Leadership Member 1" className="portrait-image" />
              <img src="/home_data/section4/8.png" alt="Leadership Member 1" className="portrait-image" /> */}
            </div>

            <div className="gallery-label">
              <h3 className="section-label">LEADERSHIP TEAM</h3>
              <h3 className="section-label">PARTNERS AND NOTABLE INVESTORS</h3>
            </div>
          </div>
        </div>

        {/* Bottom content */}
        <div className="bottom-content">
          <p className="description-text">
            {/* MEET EVERYONE BEHIND GAME 7.<br />
            A GREAT HALL OF PLAYERS MAKES A GREAT TEAM, THIS IS PEOPLE WE<br />
            ARE PROUD TO WORK WITH. */}
          </p>
          {/* <a href="https://form.typeform.com/to/LfUf3Jpc" target='_blank' className="learn-more-button">LEARN MORE</a> */}
        </div>
      </div>




      <div className="team-gallery-container-mobile">
        {/* Main content area */}
        <div>
          <AnimatedSection>
            <h3 className="the-team-title">THE TEAM</h3>
          </AnimatedSection>
          <AnimatedSection>
            <h4 className="section-label">LEADERSHIP TEAM</h4>
          </AnimatedSection>
        </div>
        <div className='team-image-phone'>
          <div className='flex flex-col gap-4'>
            <AnimatedSection><img src="/home_data/section4/mobile/11.png" alt="Leadership Member 1" className="portrait-image" />
            </AnimatedSection>
            <AnimatedSection><img src="/home_data/section4/mobile/12.png" alt="Leadership Member 1" className="portrait-image" />
            </AnimatedSection>
            <AnimatedSection><img src="/home_data/section4/mobile/13.png" alt="Leadership Member 1" className="portrait-image" />
            </AnimatedSection>
          </div>
          <div className='flex flex-col gap-4'>
            <h3 style={{ marginTop: 120 }} className="section-label">PARTNERS AND NOTABLE INVESTORS</h3>
            <AnimatedSection><img src="/home_data/section4/mobile/14.png" alt="Leadership Member 1" className="portrait-image" />
            </AnimatedSection>
            <AnimatedSection><img src="/home_data/section4/mobile/15.png" alt="Leadership Member 1" className="portrait-image" />
            </AnimatedSection>
            <AnimatedSection><img src="/home_data/section4/mobile/16.png" alt="Leadership Member 1" className="portrait-image" />
            </AnimatedSection>
            <AnimatedSection><img src="/home_data/section4/mobile/17.png" alt="Leadership Member 1" className="portrait-image" />
            </AnimatedSection>
            <AnimatedSection><img src="/home_data/section4/mobile/18.png" alt="Leadership Member 1" className="portrait-image" />
            </AnimatedSection>
          </div>
        </div>
        <div>
          <h3 className="section-label">AND MORE</h3>
        </div>
        <div className='team-section-bottome-phone'>
          <p className="description-textphone">
            MEET EVERYONE BEHIND GAME 7.<br />
            A GREAT HALL OF PLAYERS MAKES A GREAT TEAM, THIS IS PEOPLE WE<br />
            ARE PROUD TO WORK WITH.
          </p>

          {/* <a href="https://form.typeform.com/to/LfUf3Jpc" target='_blank' className="learn-more-button">LEARN MORE</a> */}

        </div>

      </div>


    </section>
  );
};

export default TeamGallery;

